export const TOP_NAV_TESTID_PREFIX = 'top-nav';

export const testIdSlug = (value?: string | number | null): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const topNavTestId = (...parts: Array<string | number | null | undefined>): string =>
  [TOP_NAV_TESTID_PREFIX, ...parts.map(testIdSlug)].filter(Boolean).join('-');

// The facility switcher decides which facility every later request is scoped to, and two
// facilities can share a display name ("Alaska"), so options are keyed by uuid, never by name.
// A facility with no uuid gets no attribute rather than a shared, ambiguous one.
export const facilityOptionTestId = (
  facilityUuid: string | null | undefined
): string | undefined =>
  testIdSlug(facilityUuid) ? topNavTestId('facility-option', facilityUuid) : undefined;

// Stable ids for the switcher and the signed-in chrome. The user menu is the signed-in anchor the
// suite asserts authentication on, so it must not change with the user's name or role.
export const TOP_NAV_TEST_IDS = {
  facilitySwitcher: topNavTestId('facility-switcher'),
  facilityListbox: topNavTestId('facility-switcher', 'listbox'),
  facilitySwitchConfirm: topNavTestId('facility-switch', 'clock-out'),
  facilitySwitchCancel: topNavTestId('facility-switch', 'remain-clocked-in'),
  mobileNavToggle: topNavTestId('mobile-nav-toggle'),
  userMenu: topNavTestId('user-menu'),
  userMenuPopover: topNavTestId('user-menu', 'popover'),
  signaturePin: topNavTestId('user-menu', 'signature-pin'),
  resetPassword: topNavTestId('user-menu', 'reset-password'),
  signOut: topNavTestId('sign-out'),
} as const;

/**
 * Props for the facility switcher's input. The testid names the control; the selected facility's
 * uuid rides on its own attribute so a spec can assert which facility it is operating as without
 * the testid itself encoding state (BOPS-262 rule 4).
 */
export const facilitySwitcherInputProps = (selectedFacilityUuid: string | null | undefined) => ({
  'data-testid': TOP_NAV_TEST_IDS.facilitySwitcher,
  'data-facility-uuid': selectedFacilityUuid || undefined,
});
